
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    current: {
      type: String,
      default: null,
    },
    previous: {
      type: String,
      default: null,
    },
    options: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
    ctx: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      masterTl: null,
      captionText: {
        split: null,
        anim: null,
      },
    }
  },
  watch: {
    current: {
      handler() {
        if (this.current === this.item._uid) {
          // expand on enter
          this.expand()
        } else {
          this.captionText.anim.reverse()
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initSplitText()

      this.$gsap.set(this.$refs.img, {
        scale: 1.2,
      })
      this.$gsap.set([this.$refs.overlay, this.$refs.captionTextContainer], {
        opacity: 0,
      })
    })
  },
  methods: {
    initSplitText() {
      this.$nextTick(() => {
        this.captionText.split = new this.$SplitText(this.$refs.captionText, {
          type: 'lines,words,chars',
          linesClass: 'overflow-hidden',
        })

        this.captionText.anim = this.$gsap.from(this.captionText.split.chars, {
          duration: 0.2,
          ease: 'circ.out',
          y: 80,
          stagger: 0.01,
        })
      })
    },
    expand() {
      this.ctx.add((self) => {
        this.masterTl = this.$gsap
          .timeline({
            defaults: {
              duration: this.options.duration,
              ease: this.options.ease,
            },
          })
          .addLabel('start', 0)
          .addLabel('end', this.options.duration)
          .set(
            this.$refs.itemContainer,
            {
              zIndex: 999,
            },
            'start'
          )
          .to(
            this.$refs.itemContainer,
            {
              scale: this.options.scale,
              x: 0,
              y: 0,
              rotation: 0,
            },
            'start'
          )
          .to(
            this.$refs.img,
            {
              scale: 1,
              duration: 0.5,
            },
            'start'
          )
          .to(
            [this.$refs.overlay, this.$refs.captionTextContainer],
            {
              opacity: 1,
              duration: 0.3,
            },
            'start'
          )

        this.captionText.anim.play()

        if (this.previous) {
          const prevItem = this.$parent.$el.querySelector(
            `[data-index="${this.previous}"]`
          )
          const prevImg = prevItem.querySelector('.grid__item-img')
          const prevOverlay = prevItem.querySelector('.grid__item-overlay')
          const prevTextContainer = prevItem.querySelector(
            '.grid__item-text-container'
          )
          const delay = 0

          // this.captionText.anim.reverse()

          this.masterTl
            .set(
              prevItem,
              {
                zIndex: 1,
                delay,
              },
              'start'
            )
            .to(
              prevItem,
              {
                scale: 1,
                x: 0,
                y: 0,
                rotation: 0,
                delay,
              },
              'start'
            )
            .to(
              [prevOverlay],
              {
                opacity: 0,
                duration: 0.5,
              },
              'start'
            )
            .to(
              prevImg,
              {
                scale: 1.2,
                duration: 0.5,
              },
              'start'
            )
          this.$gsap.to(prevTextContainer, {
            opacity: 0,
            duration: 0.3,
          })
        }

        if (this.$matchMedia('sm')) {
          // All items except the clicked one
          const filteredArray = this.$parent.items.filter(
            (otherItem) => otherItem !== this.$refs.itemContainer
          )

          for (const otherItem of filteredArray) {
            const { x, y } =
              this.current !== this.item._uid
                ? { x: 0, y: 0 }
                : this.getTranslationDistance(
                    otherItem,
                    this.$refs.itemContainer,
                    this.options.spread,
                    this.options.maxDistance
                  )

            const zIndex = Math.round(
              this.map(
                this.getDistance(otherItem, this.$refs.itemContainer),
                0,
                100000,
                998,
                1
              )
            )

            const rotationInterval = this.options.maxRotation
              ? Math.max(
                  Math.round(
                    this.map(
                      this.getDistance(otherItem, this.$refs.itemContainer),
                      0,
                      500,
                      this.options.maxRotation,
                      0
                    )
                  ),
                  0
                )
              : 0

            this.masterTl
              .set(
                otherItem,
                {
                  zIndex:
                    otherItem.dataset.index === this.item._uid ? 1 : zIndex,
                },
                otherItem.dataset.index === this.item._uid ? 'end' : 'start'
              )
              .to(
                otherItem,
                {
                  x,
                  y,
                  rotation:
                    otherItem.dataset.index === this.item._uid
                      ? 0
                      : this.$gsap.utils.random(
                          rotationInterval * -1,
                          rotationInterval
                        ),
                },
                'start'
              )
          }
        }
      })
    },
    close() {
      this.masterTl.timeScale(1.5).reverse()
      this.captionText.anim.reverse()
    },

    // utils
    /**
     * Map number x from range [a, b] to [c, d]
     * @param {Number} x - changing value
     * @param {Number} a
     * @param {Number} b
     * @param {Number} c
     * @param {Number} d
     */
    map(x, a, b, c, d) {
      return ((x - a) * (d - c)) / (b - a) + c
    },

    /**
     * Preload images
     * @param {String} selector - Selector/scope from where images need to be preloaded. Default is 'img'
     */
    // preloadImages(selector = 'img') {
    //   return new Promise((resolve) => {
    //     imagesLoaded(
    //       document.querySelectorAll(selector),
    //       { background: true },
    //       resolve
    //     )
    //   })
    // },

    /**
     * Calculates how much (x and y) the element1 needs to move away from element2 for a distance of [spread]px
     * @param {Element} element1
     * @param {Element} element2
     * @param {Number} spread - The maximum distance the element1 could have from element2. This will depend on how far the elements are from each other. The closer they are, the higher the returned values. If the distance equals or is higher than [maxDistance] then the return value will be {0,0}
     * @param {Number} maxDistance - The maximum distance between the two elements for a possible translation to occur
     * @returns {JSON} the x,y translation values
     */
    getTranslationDistance(element1, element2, spread = 80, maxDistance = 500) {
      const elCenter = {
        x: element1.offsetLeft + element1.offsetWidth / 2,
        y: element1.offsetTop + element1.offsetHeight / 2,
      }
      const elCenter2 = {
        x: element2.offsetLeft + element2.offsetWidth / 2,
        y: element2.offsetTop + element2.offsetHeight / 2,
      }
      spread = Math.max(
        this.map(
          this.getDistance(element1, element2),
          0,
          maxDistance,
          spread,
          0
        ),
        0
      )

      const angle = Math.atan2(
        Math.abs(elCenter2.y - elCenter.y),
        Math.abs(elCenter2.x - elCenter.x)
      )

      const x = Math.abs(Math.cos(angle) * spread)
      const y = Math.abs(Math.sin(angle) * spread)

      return {
        x: elCenter.x < elCenter2.x ? x * -1 : x,
        y: elCenter.y < elCenter2.y ? y * -1 : y,
      }
    },

    /**
     * Gets the distance between two elements (elemen's center)
     * @param {Element} element1
     * @param {Element} element2
     * @returns {Number} The distance value
     */
    getDistance(element1, element2) {
      const elCenter = {
        x: element1.offsetLeft + element1.offsetWidth / 2,
        y: element1.offsetTop + element1.offsetHeight / 2,
      }
      const elCenter2 = {
        x: element2.offsetLeft + element2.offsetWidth / 2,
        y: element2.offsetTop + element2.offsetHeight / 2,
      }
      return Math.hypot(elCenter.x - elCenter2.x, elCenter.y - elCenter2.y)
    },
  },
}
